// import React from "react";
import "./SecurityOneCheckInWithoutCode.scss";

const SecurityOneCheckInWithoutCode = () => {
  return (
    <div className="security-one-check-without-code-parent container">
      <div className="security-one-check-without-code">
        <h5>Check In Without Code</h5>
        <p style={{ fontSize: "12px" }}>Pick By Category</p>
      </div>
      <br />
      <div className="security-one-check-without-code-types">
        <div>
          <img alt="service icon" src="/assets/img/accessfy/taxi-icon.png" />
          <p>Cab</p>
        </div>
        <div>
          <img
            alt="service icon"
            src="/assets/img/accessfy/delivery-bike-icon.png"
          />
          <p>Food</p>
        </div>
        <div>
          <img alt="service icon" src="/assets/img/accessfy/guest-icon.png" />
          <p>Guest</p>
        </div>
        <div>
          <img
            alt="service icon"
            src="/assets/img/accessfy/delivery-icon.png"
          />
          <p>Parcel</p>
        </div>
        <div>
          <img alt="service icon" src="/assets/img/accessfy/maid-icon.png" />
          <p>Maid</p>
        </div>
        <div>
          <img alt="service icon" src="/assets/img/accessfy/plimber-icon.png" />
          <p>Plumber</p>
        </div>
        <div>
          <img alt="service icon" src="/assets/img/accessfy/menu-icon.png" />
          <p>Other</p>
        </div>
      </div>
    </div>
  );
};

export default SecurityOneCheckInWithoutCode;
